// Generated by scripts/pin-chat-widget.mts — do not edit by hand.
// Content-hash pin for the hosted chat widget (products-production-readiness 8.5).

export const CHAT_WIDGET_PIN = {
  scriptUrl: "https://widget.furistic.co/latest/index.min.js",
  integrity:
    "sha384-lsYrSXtfoeX+jF0R7FTJMSsPUI1bOJCXsIYiSD6xPv+TYP8wtr3hvSpGTATdQ243",
} as const;
